import { CurrentJourneyFont } from 'src/store/journey-dynamic-font';

export const getDynamicFontWeight = (variant: string): string => {
  switch (variant.toLowerCase()) {
    case 'light':
      return '300';
    case 'regular':
      return '400';
    case 'bold':
      return '700';
    default:
      return '400';
  }
};

export const appendDynamicFont = (
  type: 'headings' | 'paragraphs',
  { fontFamily, variant, url }: CurrentJourneyFont
) => {
  if (!url) {
    return;
  }

  const existingStyles = Array.from(document.querySelectorAll(`style[id^="dynamicFont-${type}"]`));
  existingStyles.forEach((style) => style.remove());

  const styleId = `dynamicFont-${type}`;
  const fontWeight = getDynamicFontWeight(variant);

  const style = document.createElement('style');
  style.id = styleId;

  let rootVars = ':root {\n';
  if (type === 'headings') {
    rootVars += `  --neue-canvas-headings-font-family: '${fontFamily}' !important;\n`;
    rootVars += `  --neue-canvas-headings-font-weight: ${fontWeight} !important;\n`;
  } else if (type === 'paragraphs') {
    rootVars += `  --neue-canvas-paragraphs-font-family: '${fontFamily}' !important;\n`;
    rootVars += `  --neue-canvas-paragraphs-font-weight: ${fontWeight} !important;\n`;
  }
  rootVars += '}';

  style.innerHTML = `
    @font-face {
      font-family: '${fontFamily}';
      src: url('${url}') format('truetype');
      font-weight: ${fontWeight};
      font-style: normal;
    }

    ${rootVars}
  `;

  document.head.appendChild(style);
};
